import React from 'react';
import Board from './board';
import calculateWinner from './helpers/calculateWinner';

export default class Game extends React.Component{
	
	constructor()
	{
		super();//обязательный технический вызов
		//заполненные поля тут - это значения ПО УМОЛЧАНИЮ
		this.state = {
			xIsNext: true,
			stepNumber: 0,
			history: [{
				squares: Array(9).fill(null)
			}]
		};
	}
	
	handleClick(i)
	{
		const {xIsNext, history} = this.state;
		// а почему нельзя обращаться к состояниям напрямик, вот так: this.state.history ?
		const current = history[history.length - 1];
		const squares = current.squares.slice();//slice нужен для того, чтобы получить копию массива current.squares, то есть чтобы не изменить сам массив squares. Такое изменение называется мутация и, типа, это запрещено
		if(calculateWinner(squares) || squares[i])
		{
			return;//если есть победитель
		}
		squares[i] = xIsNext ? 'X' : '0';
		this.setState({//меняем состояние, а, следовательно, перерисовываем представление
			xIsNext: !xIsNext,
			history: history.concat([{ squares: squares }]),//в history добавляем текущий массив после сделанного хода. То есть history - это массив с массивами, а индекс - номер хода.
			stepNumber: this.state.stepNumber + 1
		});
	}
	//ага, в массиве squares отражается текущее состояние на доске - там указаны все крестики и нолики
	
	paintMoves()
	{
		return this.state.history.map((step,move) => {
			const desc = move ? ('Move #' + move) : 'Начало игры';
			return (
				<li key={move}>
					<a href="#" onClick={() => {this.jumpTo(move)}}>{desc}</a>
				</li>
			);
		});
	}
	
	jumpTo(step)
	{
		this.setState({
			stepNumber: step,
			xIsNext: (step % 2) ? false : true
		});
	}
	
	render(){
		// состояние нужно прописать, чтобы его было видно в рендере
		const {xIsNext, stepNumber,history} = this.state;
		/** Строка выше аналогична записи:
		const xIsNext = this.state.xIsNext;
		const stepNumber = this.state.stepNumber;
		const history = this.state.history;
		то есть когда индексы объекта совпадают с названиями переменных
		*/
		// вспомогательные переменные
		const current = history[stepNumber];
		const winner = calculateWinner(current.squares);
		let status;
		if(winner)
		{
			status = 'Победителем стал ' + winner;
		}
		else
		{
			status = 'Next player is ' + (xIsNext ? 'X':'0');//чей ход?
		}
		return (
			<div className="game">
				<div className="game-board">
					<Board
						squares = {current.squares}
						onClick = {(i) => this.handleClick(i)}
					/>
				</div>
				<div className="game-info">
					<div>{status}</div>
					<ul>{this.paintMoves()}</ul>
				</div>
			</div>
		);
	}
	
}
// итак, идёт клик по клетке. Клик странным образом приходит наверх и в итоге выполняется функция game.js :: handleClick(i), где i - номер клетки. В этой функции, в итоге, наша модель и логика. Логика срабатывает, после этого надо поменять состояние, согласно сработавшей логики. Ок, состояние меняем, и при изменении состояния запускаются, очевидно все, функции render(). В этот render передаётся состояние (если мы это пропишем), а так как состояние изменилось, то всё отрисовывается заново и отображается на экране.


// WEBPACK FOOTER //
// ./src/game.js